import { apiRequests } from '../utilities/axios-factory'
import store from '../store'
import {
  PREPAID_TICKET_RETRIEVAL_LOOKBACK_MSECS,
  pruneManifestTripsForRetrieval
} from '@smarttransit/common-client'

const CURRENT_TRIP_MINUTES = 75

function getPassengerTrip ({ id, filter }) {
  return apiRequests.get('/v1/passenger-trip/' + id + '/', {
    params: { filter },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

function findPassengerTrips (filter) {
  return apiRequests.get('/v1/passenger-trip/join/', {
    params: { filter },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

/**
 * Fetch current/prepaid trips for a vehicle's boarded passenger hash.
 * Mirrors transport-app manifest loading so the admin live view can enrich Redis passenger rows.
 */
function getManifestPassengerTrips ({ transportationProfileId, boardedPassengerProfileIds }) {
  if (!transportationProfileId) {
    return Promise.resolve([])
  }

  const passengerProfileIds = Array.isArray(boardedPassengerProfileIds) ? boardedPassengerProfileIds : []
  const dateUpdatedFrom = new Date(Date.now() - (CURRENT_TRIP_MINUTES * 60 * 1000)).toISOString()
  const datePrepaidFrom = new Date(Date.now() - PREPAID_TICKET_RETRIEVAL_LOOKBACK_MSECS).toISOString()

  const filter = {
    where: {
      transportationProfileId,
      or: [
        { passengerProfileId: { inq: passengerProfileIds }, dateUpdated: { gt: dateUpdatedFrom } },
        { datePrepaid: { gte: datePrepaidFrom } }
      ]
    },
    include: [
      { passengerProfile: ['passengerIdentifiers', 'passengerAlternateIdentifiers', 'stUser'] },
      { passengerTransactionLogTrips: 'passengerTransactionLog' }
    ],
    order: 'dateUpdated DESC',
    limit: 500
  }

  return apiRequests.get('/v1/passenger-trip/', {
    params: { filter },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return pruneManifestTripsForRetrieval(result.data, { boardedPassengerProfileIds: passengerProfileIds })
  })
}

function findTotalPassengerTrips ({ where, join }) {
  return apiRequests.get('/v1/passenger-trip/count/join/', {
    params: { where, join },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

function findPassengerTripsPendingPayout ({ timeoutInSeconds, where, agencyId, transportationOwnerId, order, include, limit, offset }) {
  return apiRequests.get('/v1/passenger-trip/pending-payout/', {
    params: { timeoutInSeconds, where, agencyId, transportationOwnerId, order, include, limit, offset },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

function findTotalPassengerTripsPendingPayout ({ timeoutInSeconds, where, agencyId, transportationOwnerId }) {
  return apiRequests.get('/v1/passenger-trip/pending-payout/count/', {
    params: { timeoutInSeconds, where, agencyId, transportationOwnerId },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

export {
  getPassengerTrip,
  findPassengerTrips,
  getManifestPassengerTrips,
  findTotalPassengerTrips,
  findPassengerTripsPendingPayout,
  findTotalPassengerTripsPendingPayout
}
